<template>
  <section class="help">
	<header-com isTransparent/>
	<ul class="list">
	  <li  v-for="(item,index) in  list" :key="index">
		<h3 class="f32 bold">{{item.title}}</h3>
		<p class="f28 grey6">{{item.content}}</p>
	  </li>
	</ul>
  </section>
</template>

<script>
  export default {
    name: "help",
    data() {
      return {
        list:[
		  {title:'服务有效期如何计算？',content:'购买服务后自动激活，有效期以激活当日开始计算至第3个月当日24：00结束'},
		  {title:'如何换背？',content:'在’个人中心‘选择想退回的包，点击置换，48小时内寄回包包，可在任何时间点购买其它想背的包；或在商品列表选择想要背的包，进入详情页下方选择换背，购买后48小时内寄出要退回的包包。'},
		  {title:'收到包后很喜欢，不想退换了，占用换背次数么？',content:'可在已购包包列表点击“买断”后，该包将不能进行退换，也不占用服务内的换背次数。'},
		  {title:'每次可购买几件商品？',content:'一次可购买一件商品且每次服务只可绑定一个包。'},
		  {title:'服务可暂停么？',content:'一旦购买成功后，服务不可中断，直到有效期限到达自动终止。'},
		  {title:'是否可以同时拥有多个“在背”状态的包？',content:'不可以，每个服务对应一个"在背"状态的包；包包状态发生改变时，服务自动转移到下一个"在背"状态的包上;每个账户只存在一个“在背”状态的包；'},
		  {title:'商品是否为正品？如何保障？',content:'我们所提供的商品均经过专业鉴定师鉴定通过，接受第三方权威机构复检（费用自理），假一赔三，正品无忧。'},
		]
	  }
    },
    watch: {},
    computed: {},
    created() {
    },
    mounted() {
    },
    methods: {}

  }
</script>

<style lang="scss" scoped>
.help{
  padding: 148px 30px 0;
  li{
	line-height: 44px;
	h3{
	  margin-bottom: 30px;
	  padding-left: 26px;
	  position: relative;
	  &:after{
		content: '';
		width: 8px;
		height: 26px;
		position: absolute;
		left: 0;
		top:10px;
		background: $brand-color;
	  }
	}
	p{
	  margin-bottom: 34px;
	}
  }
  
}
</style>
